export const isInterestedOptions = [
  'I am interested in receiving information from SOURCE',
  'I am not interested at this time',
];
